import type { FC } from 'react';
import type { Strategy } from './types';
import styles from './Strategies.module.css';

interface StrategyCardProps {
  strategy: Strategy;
  onEdit: (strategy: Strategy) => void;
  onDelete: (strategy: Strategy) => void;
}

export const StrategyCard: FC<StrategyCardProps> = ({ strategy, onEdit, onDelete }) => {
  return (
    <div className={styles.card} onClick={() => onEdit(strategy)} aria-label={`Strategy: ${strategy.name}`}>
      <div className={styles.cardHeader}>
        <h3 className={styles.cardTitle}>{strategy.name}</h3>
        <span className={styles.typeBadge} data-variant={strategy.type}>
          {strategy.type === 'active' ? 'Active' : 'Passive'}
        </span>
      </div>
      <p className={styles.cardDescription}>{strategy.description}</p>
      <div className={styles.cardActions} onClick={(e) => e.stopPropagation()}>
        <button className={styles.smallButton} onClick={() => onEdit(strategy)} aria-label={`Edit ${strategy.name}`}>
          Edit
        </button>
        <button
          className={styles.smallButton}
          data-variant="danger"
          onClick={() => onDelete(strategy)}
          aria-label={`Delete ${strategy.name}`}
        >
          Delete
        </button>
      </div>
    </div>
  );
};
